import { TFunction } from 'i18next';
import { Namespace, useTranslation, UseTranslationOptions } from 'react-i18next';

import {
    formatAsCurrency,
    formatAsDate,
    formatAsNumber,
    formatAsNumeral,
    formatAsEmission,
    numberFormat,
    numberFormatRoundedOne,
    formatAsPercentage,
} from 'cpie-common';

export enum TranslationFormat {
    DISTANCE,
    DAYS,
    NUMERAL,
    NUMBER,
    NUMBER_ROUNDED_ONE,
    CURRENCY,
    DATE,
    EMISSION,
    PERCENT,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FormatterFunction = (value: any, format: TranslationFormat) => string;

function createFormatter(t: TFunction): FormatterFunction {
    return (value, format) => {
        switch (format) {
            case TranslationFormat.DISTANCE:
                return typeof value === 'number' ? t('translation:metrics.distance', { value }) : '';
            case TranslationFormat.CURRENCY:
                return formatAsCurrency(value);
            case TranslationFormat.DATE:
                return formatAsDate(value);
            case TranslationFormat.DAYS:
                return typeof value === 'number' ? t('translation:metrics.day', { value }) : '';
            case TranslationFormat.EMISSION:
                return formatAsEmission(value);
            case TranslationFormat.NUMBER:
                return formatAsNumber(value, numberFormat);
            case TranslationFormat.NUMBER_ROUNDED_ONE:
                return formatAsNumber(value, numberFormatRoundedOne);
            case TranslationFormat.NUMERAL:
                return formatAsNumeral(value);
            case TranslationFormat.PERCENT:
                return formatAsPercentage(value);
        }
    };
}

export function useTranslationWithFormatting(ns?: Namespace, options?: UseTranslationOptions) {
    const useTranslationResponse = useTranslation(ns, options);
    const f = createFormatter(useTranslationResponse.t);
    return Object.assign({ f }, useTranslationResponse);
}
